import type { NavigationMobileShortcutsProps } from '@maestro/commerce-blocks/components/navigation-header/navigation-header.types'

import React from 'react'

import { useNavigationMobileShortcuts } from '@maestro/commerce-blocks/components/navigation-header/batons/use-navigation-mobile-shortcuts'
import { Link } from '@pearlconvert/ui/components/link'

export default function NavigationMobileShortcuts(
  props: NavigationMobileShortcutsProps
) {
  const { shortcuts } = props
  const { handleMenuClick } = useNavigationMobileShortcuts()
  return (
    <li className="nav-mobile__item nav-mobile__item--custom">
      <ul className="nav-mobile__list">
        {shortcuts.children?.map((node, index) => (
          <li className="nav-mobile__list-item" key={index}>
            <Link
              className="nav-mobile__list-link"
              href={node?.url}
              target={node.target}
              onClick={() => handleMenuClick(node.title)}
            >
              {node?.title}
            </Link>
          </li>
        ))}
      </ul>
    </li>
  )
}
